import { TimesheetAdditionalBonusType } from "@/app/constants/timesheet/TimesheetAdditionalBonusType";

const config : Record<number, TimesheetAdditionalBonusType> = {
    0: TimesheetAdditionalBonusType.Other,
    1: TimesheetAdditionalBonusType.AdditionForExtraWork,
    2: TimesheetAdditionalBonusType.AdditionForWorkAbroad,
    3: TimesheetAdditionalBonusType.AdditionForWorkInCountry,
    4: TimesheetAdditionalBonusType.ImportFromOneLocation,
    5: TimesheetAdditionalBonusType.ImportFromMultipleLocation,
    6: TimesheetAdditionalBonusType.ImportHeavyLoad,
}

export const mapTimesheetAdditionalBonusApiToEnum = (num: number) : TimesheetAdditionalBonusType => {
    return config[num]
}

export const mapTimesheetAdditionalBonusEnumToApi = (type: TimesheetAdditionalBonusType) : number => {
    const entry = Object.entries(config).find(
        ([, value]) => value === type
    );

    if (!entry) {
        throw new Error(`Unknown TimesheetAdditionalBonusType: ${type}`);
    }

    return Number(entry[0]);
}
